import React from 'react';
import { findByText } from 'Common/Utils';
import { IntroNotice } from './IntroNotice';
import { HookShotChaperone, ClickGesture } from 'Snippets/Redundancy';

export const FormUpdateWithDoneTypingEvent = [
	{
		message: <IntroNotice />,
		find: 'a[data-chaperone-trigger]',
	},
	{
		message: (
			<>
				Firstly, We have to import <b>DoneTypingEvent</b> from <b>formydable</b>
				...
			</>
		),
		find(target) {
			return findByText(target, 'span:DoneTypingEvent')[0];
		},
	},
	{
		message: (
			<>
				The concept is still the same with <b>InputWithRules</b> in{' '}
				<b>Advance Design Pattern</b> section...
			</>
		),
		find(target) {
			return findByText(target, 'span:InputDoneTypingWithRules')[0];
		},
	},
	{
		message: (
			<>
				Except using <b>DoneTypingEvent</b> on handling change...
			</>
		),
		find(target) {
			return findByText(target, 'span:DoneTypingEvent')[1];
		},
	},
	{
		message: (
			<>
				This is how we use it we passed a callback function in the first
				parameter of <b>DoneTypingEvent</b>. that will be triggered after the
				user stop typing...
			</>
		),
		find(target) {
			return findByText(target, 'span:event')[0];
		},
	},
	{
		message: (
			<>
				And, in the second parameter we passed a miliseconds which will be the
				time lag...
			</>
		),
		find(target) {
			return findByText(target, 'span:300')[0];
		},
	},
	{
		message: (
			<>
				Then, We set-up the <b>formUpdate</b> inside the callback...
			</>
		),
		find(target) {
			return findByText(target, 'span:formUpdate')[1];
		},
	},
	{
		message: <>After that, We spread it in the form field...</>,
		find(target) {
			return findByText(target, 'span:handleDoneTyping')[1];
		},
		...HookShotChaperone({
			target: (target) => findByText(target, 'span:handleDoneTyping')[1],
			from: (target) => findByText(target, 'span:handleDoneTyping')[1],
			to: (target) => findByText(target, 'span:handleDoneTyping')[0],
		}),
	},
	{
		message: (
			<>
				Finally, We will use our component inside our container (
				<b>FormWrapper</b>). The one we created in <b>Advance Design Pattern</b>{' '}
				section...
			</>
		),
		find(target) {
			return findByText(target, 'span:InputDoneTypingWithRules')[1];
		},
	},
	{
		message: <>And That's all! Let's try out the result!</>,
		find: 'input',
		isDoneOnClick: true,
		gesture: <ClickGesture />,
		background: {
			backdropStyle: { opacity: 1 },
			highlightStyle: { backgroundColor: 'rgba(255,255,255, 1)' },
		},
	},
];

// note you cannot do controllable fields using DoneTypingEvent
